import { connectedStore } from '../../store';
import getColorPaletteConfigSelector from '../selectors/color-palette-config';

const getColorPaletteConfig = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return getColorPaletteConfigSelector(state);
};

export default getColorPaletteConfig;
